/* eslint-disable @typescript-eslint/no-explicit-any */
import { ValidationFileSize } from '@/utils/index';
import { uploadDocument } from '@/services/upload/uploadDocumentService';

type FileUploadType = {
  event: { file: File }[];
  field: string;
  fieldName: string;
  formik: any;
  documentOwner: string;
  clientId: string;
  setProofOfAddressImageURL: (value: string) => void;
  setCpfFileImageURL: (value: string) => void;
  setRgFileImageURL: (value: string) => void;
  setSelfieImageURL: (value: string) => void;
};

const fileUpload = async (props: FileUploadType): Promise<void> => {
  const {
    clientId,
    event,
    field,
    fieldName,
    documentOwner,
    formik,
    setCpfFileImageURL,
    setProofOfAddressImageURL,
    setRgFileImageURL,
    setSelfieImageURL,
  } = props;
  const { validationSize } = ValidationFileSize();
  const { setFileUpload } = uploadDocument();

  const validSize = validationSize(event, 5.0, 'MB');
  if (validSize) {
    await setFileUpload(
      clientId,
      documentOwner,
      event[0]?.file as File,
      fieldName,
    ).then(async (response) => {
      switch (field) {
        case 'proofOfAddress':
          await setProofOfAddressImageURL(response.data.url);
          await formik.setFieldValue('proofOfAddress', event[0]);
          break;
        case 'cpfFile':
          await setCpfFileImageURL(response.data.url);
          await formik.setFieldValue('cpfFile', event[0]);
          break;
        case 'rgFile':
          await setRgFileImageURL(response.data.url);
          await formik.setFieldValue('rgFile', event[0]);
          break;
        case 'selfieWithDocument':
          await setSelfieImageURL(response.data.url);
          await formik.setFieldValue('selfieWithDocument', event[0]);
          break;
        default:
      }
    });
  } else {
    formik.setFieldValue(field, {
      error:
        'O arquivo que tentou enviar ultrapassa o tamanho permitido. Por favor, insira outro arquivo',
      status: 'edit',
      ...event[0],
    });
  }
};

export default fileUpload;
